import {
  MultipleViewTypeListActiveItemPreviewHeaderActions,
  MultipleViewTypeListActiveItemPreviewHeaderToggle,
} from '../../MultipleViewTypeList'
import RequestProfile from '../RequestProfile'

import * as styles from './RequestProfilePreview.module.css'

function RequestProfilePreview({
  activeItem,
  className = styles.RequestProfilePreview,
  getProfileLink,
  profileLoadersRef,
  onClosePreview,
  onReloadList,
  onReloadListExtra,
  onSuccessMarkAsUnread,
  onSyncListItemUnread,
}) {
  function getHeaderActionsProfileLink({ id }) {
    return getProfileLink(id)
  }

  return (
    <RequestProfile
      isPreview
      headerProps={{
        Actions: MultipleViewTypeListActiveItemPreviewHeaderActions,
        BackButton: null,
        ToggleButton: MultipleViewTypeListActiveItemPreviewHeaderToggle,
        actionsProps: {
          Actions: null,
          getProfileLink: getHeaderActionsProfileLink,
          id: activeItem,
          openInNewTabButtonProps: {
            className: styles.previewOpenInNewTabButton,
          },
        },
        toggleButtonProps: { onClosePreview },
      }}
      layoutProps={{ Footer: null, className }}
      profileLoadersRef={profileLoadersRef}
      requestId={activeItem}
      onReloadList={onReloadList}
      onReloadListExtra={onReloadListExtra}
      onSuccessMarkAsUnread={onSuccessMarkAsUnread}
      onSyncListItemUnread={onSyncListItemUnread}
    />
  )
}

export default RequestProfilePreview
